import { render, staticRenderFns } from "./AIwms.vue?vue&type=template&id=a5da40b0&scoped=true"
import script from "./AIwms.vue?vue&type=script&lang=js"
export * from "./AIwms.vue?vue&type=script&lang=js"
import style0 from "./AIwms.vue?vue&type=style&index=0&id=a5da40b0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5da40b0",
  null
  
)

export default component.exports